import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.24219 12H22.0422",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.2254 21.8581L7.64062 11.9998L11.2254 2.1416",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.0586 21.8581L16.6435 11.9998L13.0586 2.1416",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.0422 11.9996C22.0422 14.6253 20.9992 17.1434 19.1425 19C17.2859 20.8566 14.7678 21.8996 12.1422 21.8996C9.51655 21.8996 6.99844 20.8566 5.14183 19C3.28522 17.1434 2.24219 14.6253 2.24219 11.9996C2.24219 9.37397 3.28522 6.85586 5.14183 4.99925C6.99844 3.14264 9.51655 2.09961 12.1422 2.09961C14.7678 2.09961 17.2859 3.14264 19.1425 4.99925C20.9992 6.85586 22.0422 9.37397 22.0422 11.9996Z",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }